/**
 * Orders placed from this browser.
 *
 * With no accounts, the tracking token is the only key to an order. It is
 * emailed to the customer, and mirrored here so that returning on the same
 * device needs no typing at all. This is a convenience cache, never the source
 * of truth: clearing site data or switching device just means using the link
 * from the email instead.
 */
const KEY = "crossborder.placedOrders";
const MAX = 50;

const read = () => {
  try {
    const raw = localStorage.getItem(KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    // Private mode, blocked storage, or corrupt JSON — behave as "none known".
    return [];
  }
};

const write = (list) => {
  try {
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
  } catch {
    /* storage unavailable — the emailed link still works */
  }
};

export const getPlacedOrders = () => read();

export const rememberPlacedOrder = ({ token, orderNumber, kind, title }) => {
  if (!token) return;
  const next = [
    { token, orderNumber, kind: kind || "order", title: title || "", placedAt: new Date().toISOString() },
    ...read().filter((o) => o.token !== token),
  ];
  write(next);
};

export const forgetPlacedOrder = (token) => write(read().filter((o) => o.token !== token));
